
/*
 * renders href attrribute
 * @param title to be displayed
 * @example <a data-bind='title: model.title'></a>
 */
ko.bindingHandlers.title = {
  update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    return ko.bindingHandlers['attr']['update'](element, (function() {
      return {
        title: valueAccessor()
      };
    }), allBindings, viewModel, bindingContext);
  }
};
